import { Check, CloudOff, Loader2 } from "lucide-react";

import { useFacilitatorSaveStatus } from "@/lib/api";

/** Small inline indicator showing whether facilitator edits have reached the
 *  server. Auto-save writes debounced; this surfaces success/failure. */
export function FacilitatorSaveStatus() {
  const status = useFacilitatorSaveStatus();

  if (status === "idle") {
    return null;
  }
  if (status === "saving") {
    return (
      <span className="text-muted inline-flex items-center gap-1.5 text-xs">
        <Loader2 className="h-3.5 w-3.5 animate-spin" />
        Saving…
      </span>
    );
  }
  if (status === "saved") {
    return (
      <span className="inline-flex items-center gap-1.5 text-xs text-emerald-600">
        <Check className="h-3.5 w-3.5" />
        All changes saved
      </span>
    );
  }
  return (
    <span className="inline-flex items-center gap-1.5 text-xs text-red-600">
      <CloudOff className="h-3.5 w-3.5" />
      Couldn&apos;t save — check your connection
    </span>
  );
}
